var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "m-subheader" }, [
      _c("div", { staticClass: "d-flex align-items-center" }, [
        _c("div", { staticClass: "mr-auto" }, [
          _c(
            "h3",
            { staticClass: "m-subheader__title m-subheader__title--separator" },
            [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm._f("titleize")(
                      _vm._f("translate")("authorizations_administration")
                    )
                  ) +
                  "\n          "
              )
            ]
          ),
          _vm._v(" "),
          _c("ul", {
            staticClass: "m-subheader__breadcrumbs m-nav m-nav--inline"
          })
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "m-content", attrs: { id: "content" } },
      [
        _c("div", { staticClass: "m-portlet m-portlet--mobile" }, [
          _c("div", { staticClass: "m-portlet__head" }, [
            _c("div", { staticClass: "m-portlet__head-caption" }, [
              _c("div", { staticClass: "m-portlet__head-title" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("h3", { staticClass: "m-portlet__head-text" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm._f("capitalize")(_vm._f("translate")("documents"))
                      ) +
                      "\n              "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "m-portlet__head-tools" }, [
              _c("ul", { staticClass: "m-portlet__nav" }, [
                _c("li", { staticClass: "m-portlet__nav-item" }, [
                  _vm.validPermission("create", "document")
                    ? _c(
                        "a",
                        {
                          staticClass: "btn btn-success m-btn m-btn--icon",
                          attrs: {
                            href: "#",
                            "data-toggle": "modal",
                            "data-backdrop": "static",
                            "data-keyboard": "false",
                            "data-target": "#documents_modal"
                          },
                          on: {
                            click: function($event) {
                              return _vm.setStatusDocumentModal(true)
                            }
                          }
                        },
                        [
                          _c("span", [
                            _c("i", { staticClass: "fa fa-plus" }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(
                                    _vm._f("capitalize")(
                                      _vm._f("translate")("create_document")
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ])
                          ])
                        ]
                      )
                    : _vm._e()
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "m-portlet__body" },
            [
              _c("s-datatable", {
                attrs: { config: _vm.datatable },
                scopedSlots: _vm._u([
                  {
                    key: "actions",
                    fn: function(props) {
                      return _c("div", {}, [
                        _vm.validPermission("modify", "document")
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "m-portlet__nav-link btn m-btn m-btn--icon m-btn--icon-only m-btn--pill btn_edit",
                                attrs: {
                                  href: "#",
                                  "data-toggle": "modal",
                                  "data-backdrop": "static",
                                  "data-keyboard": "false",
                                  "data-target": "#documents_modal"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.editDocuments(props.row)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "la la-edit" })]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.validPermission("change", "document")
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "m-portlet__nav-link btn m-btn m-btn--icon m-btn--icon-only m-btn--pill",
                                class:
                                  props.row.state == 1
                                    ? "btn_delete"
                                    : "btn_success",
                                on: {
                                  click: function($event) {
                                    return _vm.changeStatus(
                                      props.row.id,
                                      props.row.state == 1 ? 0 : 1
                                    )
                                  }
                                }
                              },
                              [_c("i", { staticClass: "la la-leaf" })]
                            )
                          : _vm._e()
                      ])
                    }
                  }
                ])
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "s-modal",
          {
            attrs: {
              id: "documents_modal",
              title: _vm._f("capitalize")(
                _vm._f("translate")(
                  _vm.edit ? "edit_document" : "create_document"
                )
              )
            }
          },
          [
            _c("s-new-document", {
              attrs: { slot: "body", data: _vm.document },
              slot: "body"
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "m-portlet__head-icon" }, [
      _c("i", { staticClass: "flaticon-suitcase" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07308c3e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07308c3e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/authorized/documents/All.vue
// module id = 626
// module chunks = 0 1 75